__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@amzn/ato-z-chat-assistant-module-website";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom/client", "0.0.0", () => (Promise.all([__webpack_require__.e(486), __webpack_require__.e(5338)]).then(() => (() => (__webpack_require__(5338))))));
			register("react-dom/client@18", "18.3.1", () => (Promise.all([__webpack_require__.e(486), __webpack_require__.e(5338)]).then(() => (() => (__webpack_require__(5338))))));
			register("react-dom", "0.0.0", () => (Promise.all([__webpack_require__.e(3884), __webpack_require__.e(961)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-dom@18", "18.3.1", () => (Promise.all([__webpack_require__.e(3884), __webpack_require__.e(961)]).then(() => (() => (__webpack_require__(40961))))));
			register("react", "0.0.0", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			register("react@18", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			register("single-spa-react/parcel", "5.1.4", () => (Promise.all([__webpack_require__.e(3884), __webpack_require__.e(4651), __webpack_require__.e(8848)]).then(() => (() => (__webpack_require__(18848))))));
			register("single-spa-react", "5.1.4", () => (__webpack_require__.e(5684).then(() => (() => (__webpack_require__(5684))))));
		}
		break;
		case "stencil@4": {
			register("@amzn/stencil-react-desc", "4.17.2", () => (__webpack_require__.e(3530).then(() => (() => (__webpack_require__(93530))))));
			register("@amzn/stencil-react-icons", "4.17.2", () => (Promise.all([__webpack_require__.e(5783), __webpack_require__.e(7081), __webpack_require__.e(3884), __webpack_require__.e(7861), __webpack_require__.e(9538)]).then(() => (() => (__webpack_require__(77157))))));
			register("@amzn/stencil-react-theme-default", "4.17.2", () => (Promise.all([__webpack_require__.e(3884), __webpack_require__.e(5690)]).then(() => (() => (__webpack_require__(95690))))));
			register("@amzn/stencil-react-utils", "4.17.2", () => (__webpack_require__.e(2612).then(() => (() => (__webpack_require__(42612))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};